/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_Stat_Stock_Sync_ValueInputs */

const tr_landing_cockpit_stat_stock_sync_value = /** @type {(inputs: Landing_Cockpit_Stat_Stock_Sync_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 2sn`)
};

const en_landing_cockpit_stat_stock_sync_value = /** @type {(inputs: Landing_Cockpit_Stat_Stock_Sync_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 2s`)
};

const de_landing_cockpit_stat_stock_sync_value = /** @type {(inputs: Landing_Cockpit_Stat_Stock_Sync_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 2 Sek.`)
};

const ru_landing_cockpit_stat_stock_sync_value = /** @type {(inputs: Landing_Cockpit_Stat_Stock_Sync_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`< 2 с`)
};

/**
* | output |
* | --- |
* | "< 2s" |
*
* @param {Landing_Cockpit_Stat_Stock_Sync_ValueInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_stat_stock_sync_value = /** @type {((inputs?: Landing_Cockpit_Stat_Stock_Sync_ValueInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Stat_Stock_Sync_ValueInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_stat_stock_sync_value(inputs)
	if (locale === "de") return de_landing_cockpit_stat_stock_sync_value(inputs)
	if (locale === "ru") return ru_landing_cockpit_stat_stock_sync_value(inputs)
	return tr_landing_cockpit_stat_stock_sync_value(inputs)
});